import React from "react";

const Impressum = () => {
  return (
    <div className="inner-wrapper">
      <div className="content">
        <h3 className="mt-5">Impressum</h3>
        <p>
          Alle Layouts der Veranstaltungen sind selbst entworfen bzw. wurden vom
          Urheber zur Veröffentlichung auf dieser Webseite genehmigt, alle
          Bilder auf der Webseite, besonders die der Kinder, wurden mit
          Einverständnis der Erziehungsberechtigten für diese Webseite
          freigegeben.Sollte sich dennoch jemand nachträglich nicht
          einverstanden erklären, bitte ich diese Person sich mit mir in
          Verbindung zu setzen.
        </p>
      </div>
    </div>
  );
};

export default Impressum;
